const removeCustomSymplifyValue = () => {
  if (window.symplify) {
    window.symplify.customValue.remove();
  }
};
export default removeCustomSymplifyValue;
